import {mapGetters, mapMutations} from "vuex";
import CONSTANTS from "@/store/constants";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";
import api from "@/api/index"
import swal from "sweetalert2";


export default {
    data() {
        return {
            cleansedData: {},
            vendorOnboardResp: {}
        }
    },
    computed: {
        ...mapGetters(["exceptionSubmissionRequestData", "currentUser"]),
    },
    methods: {
        ...mapMutations(["setCurrentTab", "setErrorMessage","setIsLoading"]),
        getValueFromList(list , value){
            let returnValue = ''
            if(value) {
                returnValue =  list.find(item => item.text === value).value
            }
            return returnValue.toString()
        },
        displayGenericCheckBox(field) {
            let genericFieldsMap = EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_MAP
            return field === genericFieldsMap.ADSK_CONSULTING_ENGAGEMENTS
                || field === genericFieldsMap.LEGAL_SERVICES
                || field === genericFieldsMap.RENT_UTILITIES
        },
        getSanitizedFormData() {
            let formData = {}
            let formObj = this.exceptionSubmissionRequestData
            formData.u_autodesk_requestor = this.currentUser.userName
            formData.u_this_request_is_for_a = this.getPreviewText(EXCEPTION_SUBMISSION_CONSTANTS.REQUEST_FOR_OPTIONS, 'exceptionRequestFor')
            formData.u_detailed_description_of_product_or_service = formObj.briefDescription
            formData.u_steps_completed_for_sponsorship = formObj.stepsCompletedForSponsorship
            formData.u_steps_completed_for_corporate_donation = formObj.stepsCompletedForCorporateDonation
            formData.u_approval_and_agreement_available_for_speaker = formObj.approvalAgreementAvailableForSpeaker
            formData.u_autodesk_company_buying_these_services = this.previewMultiSelectOptions
            formData.u_recommended_by_government_official = this.getStringValueFor(formObj.recommendedByGovernment)
            formData.u_interacting_autodesk_customers_on_our_behalf = this.getStringValueFor(formObj.onBehalfOfAutodeskCustomer)
            formData.u_does_anyone_have_relationship = this.getStringValueFor(formObj.anyRelationshipWithAutodesk)
            formData.u_approximate_spend = formObj.approximateSpend
            formData.u_do_you_need_help_finding_a_supplier = false
            formData.u_supplier_name = formObj.supplierName
            formData.u_please_provide_a_link_to_supplier_website = formObj.supplierWebsite
            formData.u_supplier_contact_name = formObj.supplierContactName
            formData.u_supplier_contact_role = formObj.supplierContactRole
            formData.u_supplier_contact_email = formObj.supplierContactEmail
            formData.u_country = formObj.supplierCountry
            formData.u_diverse_supplier_considered = formObj.diverseSupplierConsidered ? "Yes" : "No"
            formData.u_request_exit_point = EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT
            formData.u_form_status = CONSTANTS.ADSK_VENDOR_ONBOARD_STATUS.SUBMITTED
            formData.u_exception_request_description = formObj.additionalDescription
            formData.u_necessary_steps_and_supporting_documentation_completed_for_purchase = formObj.necessaryStepsAndSupportingDocumentationCompleted
            formData.u_autodesk_business_contact = formObj.requestedFor ? formObj.requestedFor : this.currentUser.userName
            formData.u_exception_corp_card_payment = formObj.corporateCardType ? formObj.corporateCardType : ""
            this.cleansedData = JSON.parse(JSON.stringify(formData))
        },
        getStringValueFor(item) {
          return item ? "Yes":"No"
        },
        getDropDownValue(array, value) {
          if(!array || array.length === 0 || !value) return null
          return array.find(obj => obj.text.toLowerCase() === value.toLowerCase()).value
        },
        async saveExceptionSubmissionRequest() {
            try{
                this.setIsLoading(true)
                this.getSanitizedFormData()
                this.vendorOnboardResp = await this.createExceptionSubmissionRequest()
                await this.submitAdditionalData(this.vendorOnboardResp)

            }catch {
                this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
            }finally {
                this.setIsLoading(false)
                this.launchConfirmationModal(this.vendorOnboardResp)
            }
        },
        async submitAdditionalData(vendorOnboardResp) {
            let RITMSysId = vendorOnboardResp.u_request_ritm.value
            await this.submitAttachments(RITMSysId)
            await this.addWatchers(RITMSysId)
        },
        getStatusDashboardUrl: function (currentUrl) {
            let url = ""
            if (currentUrl.includes(CONSTANTS.LOCALHOST_URL)) {
                url = "https://" + CONSTANTS.LOCALHOST_URL + this.$router.options.base + "/status-dashboard"
            } else {
                url = CONSTANTS.EH_URL + this.$router.options.base + "/status-dashboard";
            }
            return url;
        },
        launchConfirmationModal(vendorOnboardResponse) {
            let userMessage = "";
            const currentUrl = window.location.href;
            let statusDashboardUrl = this.getStatusDashboardUrl(currentUrl);
            if (vendorOnboardResponse["u_request_ritm.number"]) {
                let url = this.generateEmployeeHubCaseURL() + vendorOnboardResponse["u_request_ritm.number"]
                userMessage = `Created <a href=${url} target="_blank">${vendorOnboardResponse["u_request_ritm.number"]}</a> - track using <a href="${statusDashboardUrl}">My supplier requests tab</a> or <a href=${url} target="_blank">click here to view</a>`;
            } else {
                userMessage = `Track using <a href="${statusDashboardUrl}">My supplier requests tab</a>`;
            }
            userMessage += `<div class="row pt-3">Thank you for your submission.
                          If your supplier is new, they will be invited to provide their payment details
                          after Legal Compliance has completed a review.
                          You will receive an email when a new supplier record has been created.</div>`
            swal
                .fire({
                    title: `Submitted!`,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    html: userMessage,
                    showConfirmButton: true,
                    focusConfirm: false,
                    customClass: {
                        confirmButton: "flat-btn primary-blue-btn btn mb-3",
                    },
                    buttonsStyling: false,
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.$hhMixpanel.trackEvent("Supplier exception submission Form Submitted");
                        this.$router.replace("/");
                    }
                });
        },
        generateEmployeeHubCaseURL(){
            return CONSTANTS.EH_URL+'/apps/supplier-central/status-dashboard/status/'
        },
        async createExceptionSubmissionRequest() {
            let resultObj  = null
            try {
                let resp = null
                if(this.cleansedData.sys_id) {
                    resp = await api.updateSubmissionRequest(this.cleansedData)
                } else
                resp = await api.submitExceptionSubmissionRequest(this.cleansedData)
                if (resp && resp.data
                    && resp.data.result) {
                    resultObj = resp.data.result
                }
                return resultObj;
            } catch (e) {
                this.$hhMixpanel.trackEvent(CONSTANTS.MIXPANEL_API_FAILURE.VENDOR_ONBOARD_RECORD_CREATE_FAILURE);
                this.setErrorMessage(CONSTANTS.ERROR_MESSAGE)
            }

        },
        async submitAttachments(sysId) {
            if(!this.exceptionSubmissionRequestData.attachments || this.exceptionSubmissionRequestData.attachments.length === 0 ) return
            for (let i = 0; i < this.exceptionSubmissionRequestData.attachments.length; i++) {
                try {
                    await api.submitAttachmentToSnow(this.exceptionSubmissionRequestData.attachments[i].file, this.exceptionSubmissionRequestData.attachments[i].fileId, sysId)
                } catch (error) {
                    this.$hhMixpanel.trackEvent(CONSTANTS.MIXPANEL_API_FAILURE.SYS_ATTACHMENTS_API_FAILURE);
                    //no red banner as RITM already created
                }
            }
        },
        async addWatchers(RITMSysId) {
            let userId =  this.currentUser.userName
            let watchers = this.exceptionSubmissionRequestData.watchers
            try {
                await api.updateWatchers(userId, watchers, RITMSysId)
            } catch(error) {
                this.$hhMixpanel.trackEvent(CONSTANTS.MIXPANEL_API_FAILURE.SERVICE_NOW_CORE_COMPANY_API_FAILURE);
                //no red banner, as RITM is already created
            }
        },
        /* The exceptionSubmissionRequestData object has 'values' of the options that we displayed to the user, not 'text'.
        We need to extract text by finding and displaying to user from corresponding options. .*/
        getPreviewText(arrayObj, filteredValue) {
            let result = "";
            if (arrayObj) {
                let data = arrayObj.find(
                    (item) =>
                        item.value === this.exceptionSubmissionRequestData[filteredValue]
                );
                result = data && data.text;
            }

            return result;
        },
    }
}